<template>
  <div class="container text-gray-800 mx-auto">
    <div class="bg-white rounded shadow-md p-12 mx-auto my-10 w-full">
      <form class="text-center" @submit.prevent="do_submit">
        <input
          type="password"
          name="pwd"
          class="border-2 px-10 py-2 mb-3 text-center text-gray-500"
          v-model="formdata.pwd"
        />
        <button
          type="submit"
          class="bg-gray-900 hover:bg-gray-800 text-white uppercase px-10 py-2 block rounded shadow-md mx-auto"
        >
          Submit
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import hotkeys from "hotkeys-js";

export default {
  name: "PasswordPage",
  components: {},
  data() {
    return {
      key: "dailyreview45",
      formdata: {
        pwd: ""
      }
    };
  },
  computed: {
    ...mapState(["site_config"])
  },
  methods: {
    checkPwd(pwd) {
      if (this.key == pwd) {
        this.$router.push({ path: "demo" });
      }
    },
    do_submit() {
      this.checkPwd(this.formdata.pwd);
    }
  },
  mounted() {},
  watch: {
    "formdata.pwd": {
      handler: function (val, oldVal) {
        this.checkPwd(val);
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/PasswordPage.vue